import { useMemo } from "react"
import { faShieldCheck } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MRT_ColumnDef } from "material-react-table"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { fetchServerMemoryUsage, ServerMemoryUsageResponse, SupportServerMemoryQuery } from "../severMemoryApi"
import { useApiQueryTable } from "../../../../../../core/api/components/ApiQueryTable"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { ServerMemoryTypes } from "../serverMemoryTypes"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import { SUPPORT_ADMIN_ROUTE } from "../../../../../../constants/routes"
import { makeStyles } from "tss-react/mui"
import { Box } from "@mui/material"

const useStyles = makeStyles()((theme) => ({
    container: {
        width: "80%",
        [theme.breakpoints.down("lg")]: {
            width: "100%",
        },
    },
}))

const selectMemoryTypes = (data: ServerMemoryUsageResponse) => data.memoryUsage.memoryTypes

export function ServerMemoryUsage() {
    const { l10n } = useAppLocalization()
    const { classes } = useStyles()

    const serverMemoryUsageResult = useApiQuery(fetchServerMemoryUsage, {
        queryName: SupportServerMemoryQuery.MEMORY_USAGE,
        dependencies: {},
        select: selectMemoryTypes,
    })

    const { ApiQueryTable, columnFactory } = useApiQueryTable(serverMemoryUsageResult)

    const columns = useMemo<MRT_ColumnDef<ServerMemoryTypes>[]>(
        () => [
            columnFactory.nameColumn({
                header: l10n.getString("support-reports-health-server-memory-table-header-memory-type"),
                accessorKey: "type",
            }),
            columnFactory.typeColumn({
                header: l10n.getString("support-reports-health-server-memory-table-header-used"),
                accessorKey: "used",
            }),
            columnFactory.typeColumn({
                header: l10n.getString("support-reports-health-server-memory-table-header-commited"),
                accessorKey: "committed",
            }),
            columnFactory.endColumn({
                header: l10n.getString("support-reports-health-server-memory-table-header-max"),
                accessorKey: "max",
            }),
        ],
        [l10n, columnFactory],
    )

    return (
        <>
            <LocalizedStrict id="support-reports-health-server-memory-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.SUPPORT_ADMIN_HEALTH_SERVER_MEMORY}
                    title="Server memory"
                    icon={<FontAwesomeIcon icon={faShieldCheck} />}
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="support-nav-item-home">
                            <BreadcrumbLink to={SUPPORT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="support-nav-item-health">
                            <Breadcrumb>Health</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="support-nav-item-health-server-memory">
                            <Breadcrumb>Server memory</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <Box className={classes.container}>
                <ApiQueryTable
                    enableTableFooter={false}
                    enableColumnActions={false}
                    enableBottomToolbar={false}
                    enableTopToolbar={false}
                    enableRowActions={false}
                    columns={columns}
                    initialState={{ density: "spacious" }}
                />
            </Box>
        </>
    )
}
